import { FileReader, FileWriter } from '@/platform'
import FileName from '../ComControl/FileName'
import AvgButtonIndex from '../ComControl/AvgButtonIndex'
import OafDetail from '../Oaf/OafDetail'
import WelfareDetailModel from './WelfareDetailModel'
import FontProperty from '../MallNewClass/FontProperty'
import type { Screen_hash } from '../MallNewClass/GameMallNewModel'
import PropertyViewPort from './PropertyViewPort'
import WelfareGoods from './WelfareGoods'

export enum WelfareType {
    Charge = 1, // 充值
    Accumulative = 2, // 累签
    Week = 3, // 周签
    New = 4, // 新人福利
}
class WelfareModel {
    public Version: number = 1 // 数据版本
    public Opened: boolean = false // 是否开启
    public BackImage: FileName = new FileName({ type: FileName.DEF_TYPE, name: '福利_签到背景.png' }) // 商城背景图片
    public BackX: number = 0 // 商城背景X
    public BackY: number = 0 // 商城背景Y
    public DecorateImage: FileName = new FileName({ type: FileName.DEF_TYPE, name: '福利_小太平.png' }) // 装饰图层
    // public DecorateX: number = 733 // 装饰图层X坐标
    // public DecorateY: number = 68 // 装饰图层Y坐标
    public DecorateX: number = 55 // 装饰图层X坐标
    public DecorateY: number = 55 // 装饰图层Y坐标
    public IsUseOaf: boolean = false // 是否使用动图
    public OafDetailInfo: OafDetail = new OafDetail() // 动图信息
    // public CloseBtn: AvgButtonIndex = new AvgButtonIndex(48, 55, 55) // 关闭按钮图片
    public CloseBtn: AvgButtonIndex = new AvgButtonIndex(50, 55, 55) // 关闭按钮图片
    public ReceivedLogoImage: FileName = new FileName({ type: FileName.DEF_TYPE, name: '福利_已获得遮挡.png' }) // 已领取标识图
    public SigninBtn: AvgButtonIndex = new AvgButtonIndex(49, 55, 55) // 签到按钮
    public GoodsBorderImage: FileName = new FileName({ type: FileName.DEF_TYPE, name: '福利_图标框.png' }) // 商品底图
    public ReceivedBorderImage: FileName = new FileName({ type: FileName.DEF_TYPE, name: '福利_领取框.png' }) // 领取框
    public ReceivedImage: FileName = new FileName({ type: FileName.DEF_TYPE, name: '福利_已签到.png' }) // 已领取图
    public FlowerImage: FileName = new FileName({ type: FileName.DEF_TYPE, name: '商城_花.png' }) // 鲜花图
    public FlowerX: number = 55 // 鲜花图X坐标
    public FlowerY: number = 55 // 鲜花图Y坐标
    public GiftFlowerFont = new FontProperty('宋体', 12, '102,94,75') // 玩家送花数字体属性
    public GiftFlowerX: number = 55 // 玩家送花数x坐标
    public GiftFlowerY: number = 55 // 玩家送花数y坐标
    public ListWelfareDetail: WelfareDetailModel[] = [] // 福利集合
    public PublishTime: string = '0' // 发布时间
    public ModifyPosition: number = 0 // 修改来源 0=工具 1=个人中心

    private Screen_hash: Screen_hash

    constructor(Screen_hash: Screen_hash = { Width: 960, Height: 540 }) {
        this.Screen_hash = Screen_hash
        this.ListWelfareDetail = this.CreateWelfareDetailModel()
        this.Update()
    }

    // 绝对坐标
    private static readonly COORDERNATION: number[][] = [
        [
            36, 59, 509, 174, 36, 263, 509, 105, 36, 398, 509, 105, 20, 423, 854, 423, 485, 5, 434,
            35, 363, 40, 460, 35, 460, 5, 460, 5, 53, 74, 117, 74, 181, 74, 245, 74, 309, 74, 373,
            74, 437, 74, 53, 143, 117, 143, 181, 143, 245, 143, 309, 143, 373, 143, 437, 143,
        ],
        [
            400, 59, 509, 174, 400, 263, 509, 105, 400, 398, 509, 105, 20, 423, 854, 423, 5, 5, 798,
            35, 727, 40, 460, 35, 460, 5, 460, 5, 416, 74, 480, 74, 544, 74, 608, 74, 672, 74, 736,
            74, 800, 74, 416, 143, 480, 143, 544, 143, 608, 143, 672, 143, 736, 143, 800, 143,
        ],
        [
            48, 79, 679, 232, 48, 351, 678, 140, 48, 530, 678, 140, 20, 564, 1140, 564, 635, 5, 583,
            51, 484, 52, 620, 55, 620, 8, 620, 8, 70, 99, 147, 99, 224, 99, 301, 99, 378, 99, 455,
            99, 532, 99, 70, 190, 147, 190, 224, 190, 301, 190, 378, 190, 455, 190, 532, 190,
        ],
        [
            533, 79, 679, 232, 533, 351, 678, 140, 533, 530, 678, 140, 20, 564, 1140, 564, 5, 5,
            1068, 51, 969, 52, 620, 55, 620, 8, 620, 8, 555, 99, 632, 99, 709, 99, 786, 99, 863, 99,
            940, 99, 1017, 99, 555, 190, 632, 190, 709, 190, 786, 190, 863, 190, 940, 190, 1017,
            190,
        ],
        [
            36, 59, 509, 105, 36, 194, 509, 105, 36, 329, 509, 105, 20, 423, 854, 423, 485, 5, 434,
            35, 363, 40, 460, 5, 460, 5, 460, 5, 53, 74, 117, 74, 181, 74, 245, 74, 309, 74, 373,
            74, 437, 74, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        ],
        [
            400, 59, 509, 105, 400, 194, 509, 105, 400, 329, 509, 105, 20, 423, 854, 423, 5, 5, 798,
            35, 727, 40, 460, 5, 460, 5, 460, 5, 416, 74, 480, 74, 544, 74, 608, 74, 672, 74, 736,
            74, 800, 74, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        ],
        [
            48, 79, 678, 140, 48, 259, 678, 140, 48, 428, 678, 140, 20, 564, 1140, 564, 635, 5, 583,
            51, 484, 52, 620, 8, 620, 8, 620, 8, 70, 99, 147, 99, 224, 99, 301, 99, 378, 99, 455,
            99, 532, 99, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        ],
        [
            533, 79, 679, 140, 533, 259, 678, 140, 533, 428, 678, 140, 20, 564, 1140, 564, 5, 5,
            1068, 51, 969, 52, 620, 8, 620, 8, 620, 8, 555, 99, 632, 99, 709, 99, 786, 99, 863, 99,
            940, 99, 1017, 99, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
        ],
    ]

    // 相对坐标
    // 0：960；1：1280
    private static readonly COORDERNATION_RELATIVE: number[][] = [
        [
            18, 12, 12, 12, 12, 12, 16, 10, 31, 0, 48, 18, 0, 10, 0, 50, 0, 0, 46, 46, 0, 0, 46, 46,
            0, -28, 10, -20, 420, -17, 477, -21, 28, 66,
        ],
        [
            24, 14, 16, 12, 12, 12, 16, 13, 43, 0, 61, 22, 10, 19, 10, 65, 0, 0, 58, 58, 0, 0, 58,
            58, 0, -33, 10, -25, 590, -20, 647, -22, 36, 88,
        ],
    ]

    // 绝对坐标索引
    private static readonly WIN1X: number = 0
    private static readonly WIN1Y: number = 1
    private static readonly WIN1W: number = 2
    private static readonly WIN1H: number = 3
    private static readonly WIN2X: number = 4
    private static readonly WIN2Y: number = 5
    private static readonly WIN2W: number = 6
    private static readonly WIN2H: number = 7
    private static readonly WIN3X: number = 8
    private static readonly WIN3Y: number = 9
    private static readonly WIN3W: number = 10
    private static readonly WIN3H: number = 11
    private static readonly CLOSEBTNLEFTX: number = 12
    private static readonly CLOSEBTNLEFTY: number = 13
    private static readonly CLOSEBTNRIGHTX: number = 14
    private static readonly CLOSEBTNRIGHTY: number = 15
    private static readonly DECORATEX: number = 16
    private static readonly DECORATEY: number = 17
    private static readonly FLOWERX: number = 18
    private static readonly FLOWERY: number = 19
    private static readonly FLOOWERCOUNTX: number = 20
    private static readonly FLOOWERCOUNTY: number = 21
    private static readonly SIGNIN1X: number = 22
    private static readonly SIGNIN1Y: number = 23
    private static readonly SIGNIN2X: number = 24
    private static readonly SIGNIN2Y: number = 25
    private static readonly SIGNIN3X: number = 26
    private static readonly SIGNIN3Y: number = 27
    private static readonly GOODS1X: number = 28
    private static readonly GOODS1Y: number = 29
    private static readonly GOODS2X: number = 30
    private static readonly GOODS2Y: number = 31
    private static readonly GOODS3X: number = 32
    private static readonly GOODS3Y: number = 33
    private static readonly GOODS4X: number = 34
    private static readonly GOODS4Y: number = 35
    private static readonly GOODS5X: number = 36
    private static readonly GOODS5Y: number = 37
    private static readonly GOODS6X: number = 38
    private static readonly GOODS6Y: number = 39
    private static readonly GOODS7X: number = 40
    private static readonly GOODS7Y: number = 41
    private static readonly GOODS8X: number = 42
    private static readonly GOODS8Y: number = 43
    private static readonly GOODS9X: number = 44
    private static readonly GOODS9Y: number = 45
    private static readonly GOODS10X: number = 46
    private static readonly GOODS10Y: number = 47
    private static readonly GOODS11X: number = 48
    private static readonly GOODS11Y: number = 49
    private static readonly GOODS12X: number = 50
    private static readonly GOODS12Y: number = 51
    private static readonly GOODS13X: number = 52
    private static readonly GOODS13Y: number = 53
    private static readonly GOODS14X: number = 54
    private static readonly GOODS14Y: number = 55

    // 相对坐标索引
    private static readonly WELFARENAMEFONT: number = 0
    private static readonly SYNOPSISFONT: number = 1
    private static readonly GIFTFLOWERFONT: number = 2
    private static readonly GOODSNAMEFONT: number = 3
    private static readonly RECEIVINGCONDITIONFONT: number = 4
    private static readonly DAYSTIPFONT: number = 5
    private static readonly DAYSCOUNTFONT: number = 6
    private static readonly GOODSNAMEX: number = 7
    private static readonly GOODSNAMEY: number = 8
    private static readonly GOODSFLOWERX: number = 9
    private static readonly GOODSFLOWERY: number = 10
    private static readonly RECEIVINGCONDITION1X: number = 11
    private static readonly RECEIVINGCONDITION2X: number = 12
    private static readonly RECEIVINGCONDITION3X: number = 13
    private static readonly RECEIVINGCONDITION4X: number = 14
    private static readonly RECEIVINGCONDITIONY: number = 15
    private static readonly VIEWIMAGEX: number = 16
    private static readonly VIEWIMAGEY: number = 17
    private static readonly VIEWIMAGEW: number = 18
    private static readonly VIEWIMAGEH: number = 19
    private static readonly VIEWRECEIVEDLOGOX: number = 20
    private static readonly VIEWRECEIVEDLOGOY: number = 21
    private static readonly VIEWRECEIVEDLOGOW: number = 22
    private static readonly VIEWRECEIVEDLOGOH: number = 23
    private static readonly WELFARENAMEX: number = 24
    private static readonly WELFARENAMEY: number = 25
    private static readonly SYNOPSISX: number = 26
    private static readonly SYNOPSISY: number = 27
    private static readonly DAYSTIPX: number = 28
    private static readonly DAYSTIPY: number = 29
    private static readonly DAYSCOUNTX: number = 30
    private static readonly DAYSCOUNTY: number = 31
    private static readonly SIGNINW: number = 32
    private static readonly SIGNINH: number = 33

    /*
    0	960橱窗左
    1	960橱窗右
    2	1280橱窗左
    3	1280橱窗右
    4	960橱窗左7个充值
    5	960橱窗右7个充值
    6	1280橱窗左7个充值
    7	1280橱窗右7个充值
    */
    private static readonly INDEX: number[][][] = [
        [
            [0, 1],
            [2, 3],
        ],
        [
            [4, 5],
            [6, 7],
        ],
    ]

    // 创建福利
    private CreateWelfareDetailModel(): WelfareDetailModel[] {
        // 默认开启前三个福利
        const Charge = new WelfareDetailModel()
        Charge.ID = WelfareType.Charge
        Charge.Opened = true
        Charge.WindowShowImage = new FileName({ type: FileName.DEF_TYPE, name: '福利_14区域底图.png' })
        Charge.Name = '充值福利'
        Charge.Synopsis = '当鲜花大于每档数量时，每日可领取一份对应福利奖励。'

        const Accumulative = new WelfareDetailModel()
        Accumulative.ID = WelfareType.Accumulative
        Accumulative.Opened = true
        Accumulative.Name = '累签福利'
        Accumulative.Synopsis = '累计签到天数到对应天数时可领取对应福利奖励。'

        const Week = new WelfareDetailModel()
        Week.ID = WelfareType.Week
        Week.Opened = true
        Week.Name = '周签福利'
        Week.Synopsis = '每天签到，对应的日期可领取对应福利奖励。'

        const New = new WelfareDetailModel()
        New.ID = WelfareType.New
        New.Opened = false
        New.Name = '新人福利'
        New.Synopsis = '对应作品新用户签到可获得福利奖励。'

        const lstWelfareDetailModels: WelfareDetailModel[] = [Charge, Accumulative, Week, New]

        for (let i = 0; i < lstWelfareDetailModels.length; ++i) {
            let welfareDetail = lstWelfareDetailModels[i]
            welfareDetail.CreateGoods()
        }

        return lstWelfareDetailModels
    }

    /**
     * @description: 刷新
     * @param {*} windowIsRight
     * @param {*} btnBackIsRight
     * @return {*}
     */
    Update(windowIsRight = false, btnBackIsRight = false) {
        this.UpdateWelfare(windowIsRight, btnBackIsRight)

        // 排序索引 <3
        let indexWelfareDetailModel = 0

        for (let i = 0; i < this.ListWelfareDetail.length; ++i) {
            let welfareDetail = this.ListWelfareDetail[i]
            if (!welfareDetail.Opened || indexWelfareDetailModel >= 3) continue
            this.UpdateWelfareDetail(welfareDetail, windowIsRight)

            for (let j = 0; j < welfareDetail.ListWelfareGoods.length; ++j) {
                this.UpdateWelfareGoods(
                    welfareDetail,
                    welfareDetail.ListWelfareGoods[j],
                    welfareDetail.ID === WelfareType.Charge,
                    windowIsRight
                )
            }

            ++indexWelfareDetailModel
        }
    }

    /**
     * @description: 设置福利主界面坐标
     * @param {boolean} windowIsRight
     * @param {boolean} btnBackIsRight
     * @return {*}
     */
    public UpdateWelfare(windowIsRight: boolean, btnBackIsRight: boolean) {
        let row = this.ListWelfareDetail[0].ListWelfareGoods.length > 7 ? 0 : 1
        let resoulution = 0 // 分辨率索引0：960*540
        let win = Number(windowIsRight) // 窗口左右，0左，1右

        if (this.Screen_hash.Width === 1280 && this.Screen_hash.Height === 720) {
            resoulution = 1
        }

        let index = WelfareModel.INDEX[row][resoulution][win]
        this.DecorateX = WelfareModel.COORDERNATION[index][WelfareModel.DECORATEX]
        this.DecorateY = WelfareModel.COORDERNATION[index][WelfareModel.DECORATEY]

        if (btnBackIsRight) {
            this.CloseBtn.X = WelfareModel.COORDERNATION[index][WelfareModel.CLOSEBTNRIGHTX]
            this.CloseBtn.Y = WelfareModel.COORDERNATION[index][WelfareModel.CLOSEBTNRIGHTY]
        } else {
            this.CloseBtn.X = WelfareModel.COORDERNATION[index][WelfareModel.CLOSEBTNLEFTX]
            this.CloseBtn.Y = WelfareModel.COORDERNATION[index][WelfareModel.CLOSEBTNLEFTY]
        }

        this.FlowerX = WelfareModel.COORDERNATION[index][WelfareModel.FLOWERX]
        this.FlowerY = WelfareModel.COORDERNATION[index][WelfareModel.FLOWERY]

        this.GiftFlowerX = WelfareModel.COORDERNATION[index][WelfareModel.FLOOWERCOUNTX]
        this.GiftFlowerY = WelfareModel.COORDERNATION[index][WelfareModel.FLOOWERCOUNTY]

        this.GiftFlowerFont.Font_Size =
            WelfareModel.COORDERNATION_RELATIVE[resoulution][WelfareModel.GIFTFLOWERFONT]
    }

    /**
     * @description: 设置单一福利坐标
     * @param {WelfareDetailModel} welfareDetail
     * @param {boolean} windowIsRight
     * @return {*}
     */
    public UpdateWelfareDetail(welfareDetail: WelfareDetailModel, windowIsRight: boolean) {
        let rowCount = 0

        for (let i = 0; i < this.ListWelfareDetail.length; i++) {
            if (this.ListWelfareDetail[i].Opened) {
                ++rowCount
            }

            if (welfareDetail.ID === i + 1) {
                break
            }
        }

        let row = this.ListWelfareDetail[0].ListWelfareGoods.length > 7 ? 0 : 1
        let resoulution = 0 // 分辨率索引0：960*540
        let win = Number(windowIsRight) // 窗口左右，0左，1右

        if (this.Screen_hash.Width === 1280 && this.Screen_hash.Height === 720) {
            resoulution = 1
        }

        let index = WelfareModel.INDEX[row][resoulution][win]
        welfareDetail.NameX =
            WelfareModel.COORDERNATION_RELATIVE[resoulution][WelfareModel.WELFARENAMEX]
        welfareDetail.NameY =
            WelfareModel.COORDERNATION_RELATIVE[resoulution][WelfareModel.WELFARENAMEY]

        welfareDetail.DaysTipX =
            WelfareModel.COORDERNATION_RELATIVE[resoulution][WelfareModel.DAYSTIPX]
        welfareDetail.DaysTipY =
            WelfareModel.COORDERNATION_RELATIVE[resoulution][WelfareModel.DAYSTIPY]

        welfareDetail.DaysCountX =
            WelfareModel.COORDERNATION_RELATIVE[resoulution][WelfareModel.DAYSCOUNTX]
        welfareDetail.DaysCountY =
            WelfareModel.COORDERNATION_RELATIVE[resoulution][WelfareModel.DAYSCOUNTY]

        let signW = WelfareModel.COORDERNATION_RELATIVE[resoulution][WelfareModel.SIGNINW]
        let signH = WelfareModel.COORDERNATION_RELATIVE[resoulution][WelfareModel.SIGNINH]

        switch (rowCount) {
            case 1:
                welfareDetail.ViewReceived = new PropertyViewPort(
                    WelfareModel.COORDERNATION[index][WelfareModel.SIGNIN1X],
                    WelfareModel.COORDERNATION[index][WelfareModel.SIGNIN1Y],
                    signW,
                    signH
                )
                welfareDetail.ViewSignin = new PropertyViewPort(
                    WelfareModel.COORDERNATION[index][WelfareModel.SIGNIN1X],
                    WelfareModel.COORDERNATION[index][WelfareModel.SIGNIN1Y],
                    signW,
                    signH
                )
                welfareDetail.X = WelfareModel.COORDERNATION[index][WelfareModel.WIN1X]
                welfareDetail.Y = WelfareModel.COORDERNATION[index][WelfareModel.WIN1Y]
                welfareDetail.ViewWindowShow = new PropertyViewPort(
                    0,
                    0,
                    WelfareModel.COORDERNATION[index][WelfareModel.WIN1W],
                    WelfareModel.COORDERNATION[index][WelfareModel.WIN1H]
                )
                break

            case 2:
                welfareDetail.ViewReceived = new PropertyViewPort(
                    WelfareModel.COORDERNATION[index][WelfareModel.SIGNIN2X],
                    WelfareModel.COORDERNATION[index][WelfareModel.SIGNIN2Y],
                    signW,
                    signH
                )
                welfareDetail.ViewSignin = new PropertyViewPort(
                    WelfareModel.COORDERNATION[index][WelfareModel.SIGNIN2X],
                    WelfareModel.COORDERNATION[index][WelfareModel.SIGNIN2Y],
                    signW,
                    signH
                )
                welfareDetail.X = WelfareModel.COORDERNATION[index][WelfareModel.WIN2X]
                welfareDetail.Y = WelfareModel.COORDERNATION[index][WelfareModel.WIN2Y]
                welfareDetail.ViewWindowShow = new PropertyViewPort(
                    0,
                    0,
                    WelfareModel.COORDERNATION[index][WelfareModel.WIN2W],
                    WelfareModel.COORDERNATION[index][WelfareModel.WIN2H]
                )
                break

            case 3:
                welfareDetail.ViewReceived = new PropertyViewPort(
                    WelfareModel.COORDERNATION[index][WelfareModel.SIGNIN3X],
                    WelfareModel.COORDERNATION[index][WelfareModel.SIGNIN3Y],
                    signW,
                    signH
                )
                welfareDetail.ViewSignin = new PropertyViewPort(
                    WelfareModel.COORDERNATION[index][WelfareModel.SIGNIN3X],
                    WelfareModel.COORDERNATION[index][WelfareModel.SIGNIN3Y],
                    signW,
                    signH
                )
                welfareDetail.X = WelfareModel.COORDERNATION[index][WelfareModel.WIN3X]
                welfareDetail.Y = WelfareModel.COORDERNATION[index][WelfareModel.WIN3Y]
                welfareDetail.ViewWindowShow = new PropertyViewPort(
                    0,
                    0,
                    WelfareModel.COORDERNATION[index][WelfareModel.WIN3W],
                    WelfareModel.COORDERNATION[index][WelfareModel.WIN3H]
                )
                break

            default:
                break
        }

        welfareDetail.SynopsisX =
            WelfareModel.COORDERNATION_RELATIVE[resoulution][WelfareModel.SYNOPSISX]
        welfareDetail.SynopsisY =
            welfareDetail.ViewWindowShow.H +
            WelfareModel.COORDERNATION_RELATIVE[resoulution][WelfareModel.SYNOPSISY]

        welfareDetail.NameFont.Font_Size =
            WelfareModel.COORDERNATION_RELATIVE[resoulution][WelfareModel.WELFARENAMEFONT]
        welfareDetail.SynopsisFont.Font_Size =
            WelfareModel.COORDERNATION_RELATIVE[resoulution][WelfareModel.SYNOPSISFONT]
        welfareDetail.DaysTipFont.Font_Size =
            WelfareModel.COORDERNATION_RELATIVE[resoulution][WelfareModel.DAYSTIPFONT]
        welfareDetail.DaysCountFont.Font_Size =
            WelfareModel.COORDERNATION_RELATIVE[resoulution][WelfareModel.DAYSCOUNTFONT]
    }

    /**
     * @description: 设置福利商品坐标
     * @param {WelfareDetailModel} welfareDetailModel
     * @param {WelfareGoods} welfareGoods
     * @param {boolean} flowerIsShow
     * @param {boolean} windowIsRight
     * @return {*}
     */
    UpdateWelfareGoods(
        welfareDetailModel: WelfareDetailModel,
        welfareGoods: WelfareGoods,
        flowerIsShow: boolean,
        windowIsRight: boolean
    ) {
        let row = this.ListWelfareDetail[0].ListWelfareGoods.length > 7 ? 0 : 1
        let resoulution = 0 // 分辨率索引0：960*540
        let win = Number(windowIsRight) // 窗口左右，0左，1右

        if (this.Screen_hash.Width === 1280 && this.Screen_hash.Height === 720) {
            resoulution = 1
        }

        let index = WelfareModel.INDEX[row][resoulution][win]

        welfareGoods.NameX =
            WelfareModel.COORDERNATION_RELATIVE[resoulution][WelfareModel.GOODSNAMEX]
        welfareGoods.NameY =
            WelfareModel.COORDERNATION_RELATIVE[resoulution][WelfareModel.GOODSNAMEY]

        welfareGoods.FlowerIsShow = flowerIsShow
        welfareGoods.FlowerX =
            WelfareModel.COORDERNATION_RELATIVE[resoulution][WelfareModel.GOODSFLOWERX]
        welfareGoods.FlowerY =
            WelfareModel.COORDERNATION_RELATIVE[resoulution][WelfareModel.GOODSFLOWERY]
        welfareGoods.NameFont.Font_Size =
            WelfareModel.COORDERNATION_RELATIVE[resoulution][WelfareModel.GOODSNAMEFONT]

        switch (welfareDetailModel.ID) {
            case WelfareType.Charge:
                welfareGoods.ReceivingConditionX =
                    WelfareModel.COORDERNATION_RELATIVE[resoulution][
                        WelfareModel.RECEIVINGCONDITION1X
                    ]
                break

            case WelfareType.Accumulative:
                welfareGoods.ReceivingConditionX =
                    WelfareModel.COORDERNATION_RELATIVE[resoulution][
                        WelfareModel.RECEIVINGCONDITION2X
                    ]
                break

            case WelfareType.Week:
                welfareGoods.ReceivingConditionX =
                    WelfareModel.COORDERNATION_RELATIVE[resoulution][
                        WelfareModel.RECEIVINGCONDITION3X
                    ]
                break

            case WelfareType.New:
                welfareGoods.ReceivingConditionX =
                    WelfareModel.COORDERNATION_RELATIVE[resoulution][
                        WelfareModel.RECEIVINGCONDITION4X
                    ]
                break
        }

        welfareGoods.ReceivingConditionY =
            WelfareModel.COORDERNATION_RELATIVE[resoulution][WelfareModel.RECEIVINGCONDITIONY]

        welfareGoods.ViewImage = new PropertyViewPort(
            WelfareModel.COORDERNATION_RELATIVE[resoulution][WelfareModel.VIEWIMAGEX],
            WelfareModel.COORDERNATION_RELATIVE[resoulution][WelfareModel.VIEWIMAGEY],
            WelfareModel.COORDERNATION_RELATIVE[resoulution][WelfareModel.VIEWIMAGEW],
            WelfareModel.COORDERNATION_RELATIVE[resoulution][WelfareModel.VIEWIMAGEH]
        )

        welfareGoods.ViewReceivedLogo = new PropertyViewPort(
            WelfareModel.COORDERNATION_RELATIVE[resoulution][WelfareModel.VIEWRECEIVEDLOGOX],
            WelfareModel.COORDERNATION_RELATIVE[resoulution][WelfareModel.VIEWRECEIVEDLOGOY],
            WelfareModel.COORDERNATION_RELATIVE[resoulution][WelfareModel.VIEWRECEIVEDLOGOW],
            WelfareModel.COORDERNATION_RELATIVE[resoulution][WelfareModel.VIEWRECEIVEDLOGOH]
        )

        switch (welfareGoods.ID) {
            case 1:
                welfareGoods.X =
                    WelfareModel.COORDERNATION[index][WelfareModel.GOODS1X] -
                    WelfareModel.COORDERNATION[index][WelfareModel.WIN1X]
                welfareGoods.Y =
                    WelfareModel.COORDERNATION[index][WelfareModel.GOODS1Y] -
                    WelfareModel.COORDERNATION[index][WelfareModel.WIN1Y]
                break

            case 2:
                welfareGoods.X =
                    WelfareModel.COORDERNATION[index][WelfareModel.GOODS2X] -
                    WelfareModel.COORDERNATION[index][WelfareModel.WIN1X]
                welfareGoods.Y =
                    WelfareModel.COORDERNATION[index][WelfareModel.GOODS2Y] -
                    WelfareModel.COORDERNATION[index][WelfareModel.WIN1Y]
                break

            case 3:
                welfareGoods.X =
                    WelfareModel.COORDERNATION[index][WelfareModel.GOODS3X] -
                    WelfareModel.COORDERNATION[index][WelfareModel.WIN1X]
                welfareGoods.Y =
                    WelfareModel.COORDERNATION[index][WelfareModel.GOODS3Y] -
                    WelfareModel.COORDERNATION[index][WelfareModel.WIN1Y]
                break

            case 4:
                welfareGoods.X =
                    WelfareModel.COORDERNATION[index][WelfareModel.GOODS4X] -
                    WelfareModel.COORDERNATION[index][WelfareModel.WIN1X]
                welfareGoods.Y =
                    WelfareModel.COORDERNATION[index][WelfareModel.GOODS4Y] -
                    WelfareModel.COORDERNATION[index][WelfareModel.WIN1Y]
                break

            case 5:
                welfareGoods.X =
                    WelfareModel.COORDERNATION[index][WelfareModel.GOODS5X] -
                    WelfareModel.COORDERNATION[index][WelfareModel.WIN1X]
                welfareGoods.Y =
                    WelfareModel.COORDERNATION[index][WelfareModel.GOODS4Y] -
                    WelfareModel.COORDERNATION[index][WelfareModel.WIN1Y]
                break

            case 6:
                welfareGoods.X =
                    WelfareModel.COORDERNATION[index][WelfareModel.GOODS6X] -
                    WelfareModel.COORDERNATION[index][WelfareModel.WIN1X]
                welfareGoods.Y =
                    WelfareModel.COORDERNATION[index][WelfareModel.GOODS6Y] -
                    WelfareModel.COORDERNATION[index][WelfareModel.WIN1Y]
                break

            case 7:
                welfareGoods.X =
                    WelfareModel.COORDERNATION[index][WelfareModel.GOODS7X] -
                    WelfareModel.COORDERNATION[index][WelfareModel.WIN1X]
                welfareGoods.Y =
                    WelfareModel.COORDERNATION[index][WelfareModel.GOODS7Y] -
                    WelfareModel.COORDERNATION[index][WelfareModel.WIN1Y]
                break

            case 8:
                welfareGoods.X =
                    WelfareModel.COORDERNATION[index][WelfareModel.GOODS8X] -
                    WelfareModel.COORDERNATION[index][WelfareModel.WIN1X]
                welfareGoods.Y =
                    WelfareModel.COORDERNATION[index][WelfareModel.GOODS8Y] -
                    WelfareModel.COORDERNATION[index][WelfareModel.WIN1Y]
                break

            case 9:
                welfareGoods.X =
                    WelfareModel.COORDERNATION[index][WelfareModel.GOODS9X] -
                    WelfareModel.COORDERNATION[index][WelfareModel.WIN1X]
                welfareGoods.Y =
                    WelfareModel.COORDERNATION[index][WelfareModel.GOODS9Y] -
                    WelfareModel.COORDERNATION[index][WelfareModel.WIN1Y]
                break

            case 10:
                welfareGoods.X =
                    WelfareModel.COORDERNATION[index][WelfareModel.GOODS10X] -
                    WelfareModel.COORDERNATION[index][WelfareModel.WIN1X]
                welfareGoods.Y =
                    WelfareModel.COORDERNATION[index][WelfareModel.GOODS10Y] -
                    WelfareModel.COORDERNATION[index][WelfareModel.WIN1Y]
                break

            case 11:
                welfareGoods.X =
                    WelfareModel.COORDERNATION[index][WelfareModel.GOODS11X] -
                    WelfareModel.COORDERNATION[index][WelfareModel.WIN1X]
                welfareGoods.Y =
                    WelfareModel.COORDERNATION[index][WelfareModel.GOODS11Y] -
                    WelfareModel.COORDERNATION[index][WelfareModel.WIN1Y]
                break

            case 12:
                welfareGoods.X =
                    WelfareModel.COORDERNATION[index][WelfareModel.GOODS12X] -
                    WelfareModel.COORDERNATION[index][WelfareModel.WIN1X]
                welfareGoods.Y =
                    WelfareModel.COORDERNATION[index][WelfareModel.GOODS12Y] -
                    WelfareModel.COORDERNATION[index][WelfareModel.WIN1Y]
                break

            case 13:
                welfareGoods.X =
                    WelfareModel.COORDERNATION[index][WelfareModel.GOODS13X] -
                    WelfareModel.COORDERNATION[index][WelfareModel.WIN1X]
                welfareGoods.Y =
                    WelfareModel.COORDERNATION[index][WelfareModel.GOODS13Y] -
                    WelfareModel.COORDERNATION[index][WelfareModel.WIN1Y]
                break

            case 14:
                welfareGoods.X =
                    WelfareModel.COORDERNATION[index][WelfareModel.GOODS14X] -
                    WelfareModel.COORDERNATION[index][WelfareModel.WIN1X]
                welfareGoods.Y =
                    WelfareModel.COORDERNATION[index][WelfareModel.GOODS14Y] -
                    WelfareModel.COORDERNATION[index][WelfareModel.WIN1Y]
                break

            default:
                break
        }
    }

    WindowIsRight() {
        // TODO
    }

    BackBtnIsRight() {
        // TODO
    }

    // 转换成二进制数据
    WriteData() {
        // TODO
    }

    // Graphics下的路径
    ImportPics() {
        // TODO
    }

    // 创建按钮
    CreateBtn() {
        // TODO
    }

    // 导入素材
    ImportMaterial() {
        // TODO
    }

    // 导入素材
    GetValueClone() {
        // TODO
    }

    readVersionedOui(reader: FileReader): void {
        this.Version = reader.readInt()
        this.Opened = reader.readInt() == 1 ? true : false
        this.BackImage.readVersionedOui(reader.readObj(reader.readInt()))
        this.DecorateImage.readVersionedOui(reader.readObj(reader.readInt()))
        this.DecorateX = reader.readInt()
        this.DecorateY = reader.readInt()
        this.IsUseOaf = reader.readInt() == 1 ? true : false
        this.OafDetailInfo.readVersionedOui(reader.readObj(reader.readInt()))
        this.CloseBtn.readVersionedOui(reader.readObj(reader.readInt()))
        this.ReceivedLogoImage.readVersionedOui(reader.readObj(reader.readInt()))
        this.SigninBtn.readVersionedOui(reader.readObj(reader.readInt()))
        this.GoodsBorderImage.readVersionedOui(reader.readObj(reader.readInt()))
        this.ReceivedBorderImage.readVersionedOui(reader.readObj(reader.readInt()))
        this.ReceivedImage.readVersionedOui(reader.readObj(reader.readInt()))
        this.FlowerImage.readVersionedOui(reader.readObj(reader.readInt()))
        this.FlowerX = reader.readInt()
        this.FlowerY = reader.readInt()
        this.GiftFlowerFont.readVersionedOui(reader.readObj(reader.readInt()))
        this.GiftFlowerX = reader.readInt()
        this.GiftFlowerY = reader.readInt()

        const detailLen = reader.readInt()
        this.ListWelfareDetail = []
        for (let i = 0; i < detailLen; i++) {
            const detail = new WelfareDetailModel()
            detail.readVersionedOui(reader.readObj(reader.readInt()))
            this.ListWelfareDetail.push(detail)
        }

        if (this.Version >= 2) {
            // 充值福利领取条件丸子数
            if (!reader.isReadEnd()) {
                let cnt = reader.readInt()
                if (cnt > 0) {
                    for (let index = 0; index < cnt; index++) {
                        const condition = reader.readInt()
                        const conditionDiscription = reader.readString()

                        if (index < this.ListWelfareDetail[0].ListWelfareGoods.length) {
                            this.ListWelfareDetail[0].ListWelfareGoods[
                                index
                            ].ReceivingConditionPakoras = condition
                            this.ListWelfareDetail[0].ListWelfareGoods[
                                index
                            ].ReceivingConditionDiscriptionPakoras = conditionDiscription
                        }
                    }
                }

                this.PublishTime = reader.readString()
                this.ModifyPosition = reader.readInt()
                this.BackX = reader.readInt()
                this.BackY = reader.readInt()
            }
        } else {
            this.Version = 2
        }
    }

    writeVersionedOui(writer: FileWriter): void {
        // writer.writerIntLength()

        writer.writeInt(this.Version)
        writer.writeInt(this.Opened ? 1 : 0)
        this.BackImage.writeVersionedOui(writer)
        this.DecorateImage.writeVersionedOui(writer)
        writer.writeInt(this.DecorateX)
        writer.writeInt(this.DecorateY)
        writer.writeInt(this.IsUseOaf ? 1 : 0)
        this.OafDetailInfo.writeVersionedOui(writer)
        this.CloseBtn.writeVersionedOui(writer)
        this.ReceivedLogoImage.writeVersionedOui(writer)
        this.SigninBtn.writeVersionedOui(writer)
        this.GoodsBorderImage.writeVersionedOui(writer)
        this.ReceivedBorderImage.writeVersionedOui(writer)
        this.ReceivedImage.writeVersionedOui(writer)
        this.FlowerImage.writeVersionedOui(writer)
        writer.writeInt(this.FlowerX)
        writer.writeInt(this.FlowerY)
        this.GiftFlowerFont.writeVersionedOui(writer)
        writer.writeInt(this.GiftFlowerX)
        writer.writeInt(this.GiftFlowerY)

        if (this.ListWelfareDetail.length > 0) {
            writer.writeInt(this.ListWelfareDetail.length)
            for (let i = 0; i < this.ListWelfareDetail.length; i++) {
                const detail = this.ListWelfareDetail[i]
                detail.writeVersionedOui(writer)
            }
        } else {
            writer.writeInt(0)
        }

        if (this.Version >= 2) {
            // 丸子数据
            if (this.ListWelfareDetail.length > 0) {
                writer.writeInt(this.ListWelfareDetail[0].ListWelfareGoods.length)
                for (let i = 0; i < this.ListWelfareDetail[0].ListWelfareGoods.length; i++) {
                    const welfareGoods = this.ListWelfareDetail[0].ListWelfareGoods[i]
                    writer.writeInt(welfareGoods.ReceivingConditionPakoras)
                    writer.writeString(welfareGoods.ReceivingConditionDiscriptionPakoras)
                }
            } else {
                writer.writeInt(0)
            }

            writer.writeString(this.PublishTime)
            writer.writeInt(this.ModifyPosition)
            writer.writeInt(this.BackX)
            writer.writeInt(this.BackY)
        }

        // writer.writerLength()
    }
    /**
     * @description: 重置商品列表
     * @param {WelfareDetailModel} welfareDetailModel
     * @param {number} count 商品数量
     * @return {*}
     */
    ResizeGoodsList(welfareDetailModel: WelfareDetailModel, count: number) {
        if (welfareDetailModel.ListWelfareGoods.length === count) return

        if (count > welfareDetailModel.ListWelfareGoods.length) {
            for (let i = welfareDetailModel.ListWelfareGoods.length; i < count; i++) {
                const welfareGoods = new WelfareGoods()
                welfareGoods.ID = i + 1

                welfareGoods.Name += welfareGoods.ID
                welfareGoods.ReceivingCondition =
                    welfareDetailModel.ListWelfareGoods[i - 1].ReceivingCondition + 1
                welfareGoods.ReceivingConditionPakoras =
                    welfareDetailModel.ListWelfareGoods[i - 1].ReceivingConditionPakoras + 1

                const welfareType: WelfareType = welfareDetailModel.ID

                switch (welfareType) {
                    case WelfareType.Charge:
                        if (welfareGoods.ReceivingCondition > WelfareGoods.CONDITION_CHARGE_MAX) {
                            welfareGoods.ReceivingCondition = WelfareGoods.CONDITION_CHARGE_MAX
                        }

                        if (
                            welfareGoods.ReceivingConditionPakoras >
                            WelfareGoods.CONDITION_CHARGE_PAKORAS_MAX
                        ) {
                            welfareGoods.ReceivingConditionPakoras =
                                WelfareGoods.CONDITION_CHARGE_PAKORAS_MAX
                        }

                        break

                    case WelfareType.Accumulative:
                        if (
                            welfareGoods.ReceivingCondition >
                            WelfareGoods.CONDITION_ACCUMULATIVE_MAX
                        ) {
                            welfareGoods.ReceivingCondition =
                                WelfareGoods.CONDITION_ACCUMULATIVE_MAX
                        }
                        break

                    case WelfareType.Week:
                        break

                    case WelfareType.New:
                        if (welfareGoods.ReceivingCondition > WelfareGoods.CONDITION_NEW_MAX) {
                            welfareGoods.ReceivingCondition = WelfareGoods.CONDITION_NEW_MAX
                        }
                        break
                    default:
                        break
                }

                this.UpdateWelfareGoods(
                    welfareDetailModel,
                    welfareGoods,
                    welfareDetailModel.ID === WelfareType.Charge,
                    false
                )
                this.GenerateCoordinationFromOther(
                    welfareGoods,
                    welfareDetailModel.ListWelfareGoods[0]
                )

                welfareDetailModel.ListWelfareGoods.push(welfareGoods)
            }

            welfareDetailModel.UpdateConditionDiscription()
        } else {
            welfareDetailModel.ListWelfareGoods.splice(
                count,
                welfareDetailModel.ListWelfareGoods.length - count
            )
        }
    }

    /**
     * @description: 根据之前的坐标获取新实际坐标
     * @param {WelfareGoods} goods_new
     * @param {WelfareGoods} welfare_other
     * @return {*}
     */
    GenerateCoordinationFromOther(goods_new: WelfareGoods, welfare_other: WelfareGoods) {
        let coord_other = this.GetWelfareGoodsCoordinate(welfare_other.ID)
        let coord_current = this.GetWelfareGoodsCoordinate(goods_new.ID)

        goods_new.X = welfare_other.X + coord_current[0] - coord_other[0]
        goods_new.Y = welfare_other.Y + coord_current[1] - coord_other[1]
    }

    /**
     * @description: 设置福利商品坐标
     * @param {number} id
     * @return {*}
     */
    GetWelfareGoodsCoordinate(id: number) {
        let row = id > 7 ? 0 : 1
        let resoulution = 0 // 分辨率索引0：960*540
        let win = 0 // 窗口左右，0左，1右

        if (this.Screen_hash.Width == 1280 && this.Screen_hash.Height == 720) {
            resoulution = 1
        }

        let index = WelfareModel.INDEX[row][resoulution][win]
        const cordinate = [0, 0]

        switch (id) {
            case 1:
                cordinate[0] =
                    WelfareModel.COORDERNATION[index][WelfareModel.GOODS1X] -
                    WelfareModel.COORDERNATION[index][WelfareModel.WIN1X]
                cordinate[1] =
                    WelfareModel.COORDERNATION[index][WelfareModel.GOODS1Y] -
                    WelfareModel.COORDERNATION[index][WelfareModel.WIN1Y]
                break

            case 2:
                cordinate[0] =
                    WelfareModel.COORDERNATION[index][WelfareModel.GOODS2X] -
                    WelfareModel.COORDERNATION[index][WelfareModel.WIN1X]
                cordinate[1] =
                    WelfareModel.COORDERNATION[index][WelfareModel.GOODS2Y] -
                    WelfareModel.COORDERNATION[index][WelfareModel.WIN1Y]
                break

            case 3:
                cordinate[0] =
                    WelfareModel.COORDERNATION[index][WelfareModel.GOODS3X] -
                    WelfareModel.COORDERNATION[index][WelfareModel.WIN1X]
                cordinate[1] =
                    WelfareModel.COORDERNATION[index][WelfareModel.GOODS3Y] -
                    WelfareModel.COORDERNATION[index][WelfareModel.WIN1Y]
                break

            case 4:
                cordinate[0] =
                    WelfareModel.COORDERNATION[index][WelfareModel.GOODS4X] -
                    WelfareModel.COORDERNATION[index][WelfareModel.WIN1X]
                cordinate[1] =
                    WelfareModel.COORDERNATION[index][WelfareModel.GOODS4Y] -
                    WelfareModel.COORDERNATION[index][WelfareModel.WIN1Y]
                break

            case 5:
                cordinate[0] =
                    WelfareModel.COORDERNATION[index][WelfareModel.GOODS5X] -
                    WelfareModel.COORDERNATION[index][WelfareModel.WIN1X]
                cordinate[1] =
                    WelfareModel.COORDERNATION[index][WelfareModel.GOODS5Y] -
                    WelfareModel.COORDERNATION[index][WelfareModel.WIN1Y]
                break

            case 6:
                cordinate[0] =
                    WelfareModel.COORDERNATION[index][WelfareModel.GOODS6X] -
                    WelfareModel.COORDERNATION[index][WelfareModel.WIN1X]
                cordinate[1] =
                    WelfareModel.COORDERNATION[index][WelfareModel.GOODS6Y] -
                    WelfareModel.COORDERNATION[index][WelfareModel.WIN1Y]
                break

            case 7:
                cordinate[0] =
                    WelfareModel.COORDERNATION[index][WelfareModel.GOODS7X] -
                    WelfareModel.COORDERNATION[index][WelfareModel.WIN1X]
                cordinate[1] =
                    WelfareModel.COORDERNATION[index][WelfareModel.GOODS7Y] -
                    WelfareModel.COORDERNATION[index][WelfareModel.WIN1Y]
                break

            case 8:
                cordinate[0] =
                    WelfareModel.COORDERNATION[index][WelfareModel.GOODS8X] -
                    WelfareModel.COORDERNATION[index][WelfareModel.WIN1X]
                cordinate[1] =
                    WelfareModel.COORDERNATION[index][WelfareModel.GOODS8Y] -
                    WelfareModel.COORDERNATION[index][WelfareModel.WIN1Y]
                break

            case 9:
                cordinate[0] =
                    WelfareModel.COORDERNATION[index][WelfareModel.GOODS9X] -
                    WelfareModel.COORDERNATION[index][WelfareModel.WIN1X]
                cordinate[1] =
                    WelfareModel.COORDERNATION[index][WelfareModel.GOODS9Y] -
                    WelfareModel.COORDERNATION[index][WelfareModel.WIN1Y]
                break

            case 10:
                cordinate[0] =
                    WelfareModel.COORDERNATION[index][WelfareModel.GOODS10X] -
                    WelfareModel.COORDERNATION[index][WelfareModel.WIN1X]
                cordinate[1] =
                    WelfareModel.COORDERNATION[index][WelfareModel.GOODS10Y] -
                    WelfareModel.COORDERNATION[index][WelfareModel.WIN1Y]
                break

            case 11:
                cordinate[0] =
                    WelfareModel.COORDERNATION[index][WelfareModel.GOODS11X] -
                    WelfareModel.COORDERNATION[index][WelfareModel.WIN1X]
                cordinate[1] =
                    WelfareModel.COORDERNATION[index][WelfareModel.GOODS11Y] -
                    WelfareModel.COORDERNATION[index][WelfareModel.WIN1Y]
                break

            case 12:
                cordinate[0] =
                    WelfareModel.COORDERNATION[index][WelfareModel.GOODS12X] -
                    WelfareModel.COORDERNATION[index][WelfareModel.WIN1X]
                cordinate[1] =
                    WelfareModel.COORDERNATION[index][WelfareModel.GOODS12Y] -
                    WelfareModel.COORDERNATION[index][WelfareModel.WIN1Y]
                break

            case 13:
                cordinate[0] =
                    WelfareModel.COORDERNATION[index][WelfareModel.GOODS13X] -
                    WelfareModel.COORDERNATION[index][WelfareModel.WIN1X]
                cordinate[1] =
                    WelfareModel.COORDERNATION[index][WelfareModel.GOODS13Y] -
                    WelfareModel.COORDERNATION[index][WelfareModel.WIN1Y]
                break

            case 14:
                cordinate[0] =
                    WelfareModel.COORDERNATION[index][WelfareModel.GOODS14X] -
                    WelfareModel.COORDERNATION[index][WelfareModel.WIN1X]
                cordinate[1] =
                    WelfareModel.COORDERNATION[index][WelfareModel.GOODS14Y] -
                    WelfareModel.COORDERNATION[index][WelfareModel.WIN1Y]
                break

            default:
                break
        }

        return cordinate
    }
}

export default WelfareModel
